<template>
  <div
    class="modal fade"
    id="menuWModal"
    tabindex="-1"
    aria-labelledby="menuWModalLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              메뉴 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">
          <div class="modalDivWrap">
            <div class="modalInputDiv">
              <label for="">카테고리</label>
              <input
                type="text"
                placeholder="카테고리 이름을 입력해주세요."
                v-model="submitForm.category"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">메뉴명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="카테고리 아래 등록될 메뉴 이름을 입력해주세요."
                v-model="submitForm.menu"
              />
            </div>
            <div class="modalInputDiv">
              <label for="">노출 대상<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj" v-for="(item, i) in roleList" :key="item.key">
                  <input 
                  type="radio" 
                  :value="item.key"
                  :id="item.key+'W'"
                  v-model="submitForm.targetType"
                  /> 
                  <label :for="item.key+'W'">{{ item.label }}</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">링크명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="url을 입력해주세요(예: /manufacturer/list)."
                v-model="submitForm.url"
              />
            </div>
            <div class="modalInputDiv logo">
              <label for="">기본 아이콘<span class="requiredSpan">*</span></label>
              <div class="modal-input-content">
                <img 
                  ref="inactiveLogoPreview"
                  :src="submitForm.inactiveImageUrl"
                  style="display: none;"
                >
                <button 
                  class="btn btn-primary"
                  ref="inactiveRemoveBtn"
                  @click="removeLogoImage('inactive')"
                  style="margin-bottom: 0!important; display: none;"
                >
                  x
                </button>
                <button 
                  class="btn btn-primary"
                  @click="openLogoFileInput('inactive')"
                  style="margin-bottom: 0!important;"
                >이미지 업로드</button>
                <input
                  type="file"
                  accept="image/jpeg, image/png, image/svg+xml"
                  ref="inactiveLogoFileInput"
                  @change="changeLogoImage('inactive')"
                />
              </div>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                마우스 커서를 올리지 않았을 때의 기본 아이콘입니다. 정사각형 사이즈를 권장합니다.
              </div>
            </div>
            <div class="modalInputDiv logo">
              <label for="">활성화 시 아이콘<span class="requiredSpan">*</span></label>
              <div class="modal-input-content">
                <img 
                  ref="activeLogoPreview"  
                  :src="submitForm.activeImageUrl"
                  style="display: none;"
                >
                <button 
                  class="btn btn-primary"
                  ref="activeRemoveBtn"
                  @click="removeLogoImage('active')"
                  style="margin-bottom: 0!important; display: none;"
                >
                  x
                </button>
                <button 
                  class="btn btn-primary"
                  @click="openLogoFileInput('active')"
                  style="margin-bottom: 0!important;"
                >이미지 업로드</button>
              </div>
              <input
                type="file"
                accept="image/jpeg, image/png, image/svg+xml"
                ref="activeLogoFileInput"
                @change="changeLogoImage('active')"
              />
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                현재 접속중인 페이지에 해당하는 아이콘입니다. 정사각형 사이즈를 권장합니다.
              </div>
            </div>
            <div class="modalInputDiv">
              <label for="">새 창 여부</label>
              <div class="radioWrap">
                <div class="radioObj">
                  <input 
                  type="checkbox" 
                  id="newWindowW" 
                  v-model="submitForm.needsNewWindow"
                  /> 
                  <label :for="'newWindowW'">클릭 시 새 창 열기</label>
                </div>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                새 창에서 열리는 페이지의 경우 체크해 주세요(예: 병원페이지의 사용 가이드). 
              </div>
            </div>
            <div class="modalInputDiv">
              <label for="">읽기 권한 세분화</label>
              <div class="radioWrap read-options-container">
                <div class="radioObj">
                  <input 
                  type="checkbox" 
                  id="needsReadOptionsW" 
                  v-model="needsReadOptions"
                  @change="handleNeedsReadOptions"
                  /> 
                  <label :for="'needsReadOptionsW'">읽기 권한 세분화</label>
                </div>
                  <div class="readoptions-list" v-if="needsReadOptions">
                    <div class="option-row" v-for="(item, index) in submitForm.readOptions">
                      <input 
                        type="text"
                        v-model="item.key"
                        >
                      <div class="radioObj">
                        <input 
                          type="radio" 
                          :id="'defaultReadOptionIndex' + index"
                          :value="index"
                          v-model="submitForm.defaultReadOptionIndex"
                          @change="handleIndexChange"
                        /> 
                        <label :for="'defaultReadOptionIndex' + index">기본값으로 설정</label>
                      </div>
                      <button
                        @click="removeReadOption(index)"
                      >
                        -
                      </button>
                    </div>
                  </div>
                  <button 
                    class=""
                    v-if="needsReadOptions"
                    @click="addReadOption"
                  >
                    추가
                  </button>
              </div>
            </div>
            <div class="modalInputDiv">
              <label for=""/>
              <div class="modalTextSmall">
                병원/제조사 직원들의 읽기 권한을 차등 부여할 수 있습니다.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="addMenu"
          >
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  openDialog, 
  changeBytesToKilos, 
  convertBoolToYn,
} from '@/utils/utils';
import { YnEnum } from '@/enums/common.enums';

export default {
  props: {
    roles: Object,
  },
  data() {
    return {
      roleList: this.roles,
      needsReadOptions: false,

      submitForm: {
        category: '',
        menu: '',
        targetType: '',
        url: '',
        activeImageData: null,
        inactiveImageData: null,
        activeImageUrl: '',
        inactiveImageUrl: '',
        needsNewWindow: false,
        readOptions: [],
        defaultReadOptionIndex: null, 
      },
      
    };
  },
/*
{
  'category': '치아',
  'name': '발행내역조회',
  'role': 'MANUFACTURER',
  'link': '/dashboard',
  'iconDefaultUrl': '/default.png',
  'iconActiveUrl': '/active.png',
  'isNewWindow': 'Y or N'
}
*/
  async mounted() {
    this.addReadOption();
  },
  methods: {
    async addReadOption() {
      const obj = {
        key: '',
        value: YnEnum.N,
      }
      if(this.submitForm.readOptions.length === 0) {
        this.submitForm.defaultReadOptionIndex = 0;
        obj.value = YnEnum.Y;
      }
      this.submitForm.readOptions.push(obj);
    },
    async removeReadOption(index) {
      if (index === this.submitForm.defaultReadOptionIndex) {
        this.submitForm.defaultReadOptionIndex = null;
      } else if (index < this.submitForm.defaultReadOptionIndex) {
        this.submitForm.defaultReadOptionIndex--;
      }
      this.submitForm.readOptions.splice(index, 1);
    },
    handleIndexChange() {
      const targetIndex = this.submitForm.defaultReadOptionIndex;
      this.submitForm.readOptions.map((item, index) => {
        if(targetIndex === index) {
          item.value = YnEnum.Y;
        } else {
          item.value = YnEnum.N;
        }
      })
    },
    handleNeedsReadOptions() {
      if(!this.needsReadOptions) this.submitForm.readOptions = [{key: ''}];
    },
    async addMenu() {
      if(!await this.validateData()) return;
      try {
        const activeImageUrl = await this.uploadImageOnObjectStorage(this.submitForm.activeImageData);
        const inactiveImageUrl = await this.uploadImageOnObjectStorage(this.submitForm.inactiveImageData);
        if(!activeImageUrl || !inactiveImageUrl) {
          throw new Error('파일 업로드 중 오류가 발생하였습니다.');
        }

        const obj = {};
        obj.category = this.submitForm.category;
        obj.name = this.submitForm.menu;
        obj.role = this.submitForm.targetType;
        obj.link = this.submitForm.url;
        obj.iconDefaultUrl = inactiveImageUrl;
        obj.iconActiveUrl = activeImageUrl;
        obj.isNewWindow = convertBoolToYn(this.submitForm.needsNewWindow);
        if(this.needsReadOptions) {
          obj.readOptions = this.submitForm.readOptions.filter(item => item.key !== '').map((item, index) => {
            return {
              key: item.key,
              value: index === this.submitForm.defaultReadOptionIndex
              ? YnEnum.Y :YnEnum.N
            }
          });
        }
        console.log(Array.isArray(this.submitForm.readOptions) , this.submitForm.readOptions.length > 0)
        const response = await this.$apiInstance.post(`/menus`, obj);
        if(response.status !== 200 && response.status !== 201) {
          throw new Error('서버와의 통신에 문제가 발생했습니다.');
        };

        await openDialog('메뉴 생성이 완료되었습니다.', 'success', '확인')
          .then(() => {
            location.reload();
          });


        
      } catch(error) {
        console.log(error);
        openDialog(error.message, 'error', '확인');
      }
    },
    /*
      type:String
      'inactive' or 'active'
    */
    openLogoFileInput(type) {
      console.log(type)
      const input = this.$refs[`${type}LogoFileInput`];
      if(!input) return;
      input.click();
    },

    async changeLogoImage(type) {
      const fileInput = this.$refs[`${type}LogoFileInput`];
      if(!fileInput) {
        console.log('no target file input found');
        return;
      }
      const targetImg = this.$refs[`${type}LogoPreview`];
      const targetBtn = this.$refs[`${type}RemoveBtn`];
      const page = this;

      if (fileInput.files && fileInput.files[0]) {
        const validateFile = await this.validateFile(fileInput.files[0]);
        if(!targetImg) return;
        if(validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            targetImg.src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          targetImg.classList.remove('hide');
          targetImg.style.display = 'block';
          targetBtn.style.display = 'block';
          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          page.submitForm[`${type}ImageData`] = formData;
        };
      } else {
        targetImg.src = '';
        targetImg.style.display = 'none';
        targetBtn.style.display = 'none';
      }
    },

    removeLogoImage(type) {
      if(!type) return;
      const targetImg = this.$refs[`${type}LogoPreview`];
      const targetBtn = this.$refs[`${type}RemoveBtn`];
      targetImg.src = '';
      targetImg.style.display = 'none';
      targetBtn.style.display = 'none';
    },
    async validateData() {
      if(!this.submitForm.menu) {
        await openDialog('메뉴명을 입력해주세요.', 'error', '확인');
        return false;
      }
      if(!this.submitForm.targetType) {
        await openDialog('노출 대상을 선택해주세요.', 'error', '확인');
        return false;
      }
      if(!this.submitForm.url) {
        await openDialog('링크를 입력해주세요.', 'error', '확인');
        return false;
      }
      if(!this.submitForm.inactiveImageData) {
        await openDialog('기본 아이콘을 업로드해주세요.', 'error', '확인');
        return false;
      }
      if(!this.submitForm.activeImageData) {
        await openDialog('활성화 시 아이콘을 업로드해주세요.', 'error', '확인');
        return false;
      }

      if(!this.needsReadOptions) return true;

      if(this.submitForm.readOptions.some(item => item.key === '')) {
        await openDialog('권한 기본값을 입력해 주세요.', 'error', '확인');
        return false;
      }

      if(this.submitForm.defaultReadOptionIndex === null) {
        await openDialog('권한 기본값을 올바르게 설정해 주세요.', 'error', '확인');
        return false;
      }      

      const defaultReadOptionItem = 
        this.submitForm.readOptions[this.submitForm.defaultReadOptionIndex];
      const isDefaultValueWrong = defaultReadOptionItem.key === '' || 
        this.submitForm.defaultReadOptionIndex === null;

      if(isDefaultValueWrong) {
        await openDialog('권한 기본값을 올바르게 설정해 주세요.', 'error', '확인');
        return false;
      }

      const allN = this.submitForm.readOptions.length > 0 &&
        this.submitForm.readOptions.every(item => item.value === 'N');

      if(allN) {
        await openDialog('권한 기본값을 올바르게 설정해 주세요.', 'error', '확인');
        return false;
      }

      return true;
    },
    async validateFile(file) {
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/svg+xml' 
      ) {
        await openDialog('png, svg 파일만 첨부 가능합니다.', 'error', '확인');
        return false;
      } else if (changeBytesToKilos(file.size) > 100) {
        await openDialog('파일 크기가 100MB를 초과합니다.', 'error', '확인');
        return false;
      }
      return true;
    },
    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/menu-manage.scss';
</style>
